// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"37a3e2a4","150":"b474bf21","495":"a14f335d","973":"c5e0d2a3"}[chunkId] + ".chunk.js";
};